import { Spin } from 'antd';
import { Suspense } from 'react';
import { lazyRoute } from 'infra/routes/lazy-route';
import { Navigate, useParams } from 'react-router-dom';
import { FlagGatedRoute } from 'infra/routes/flag-gated-route.component';

const ScoutingPlanPage = lazyRoute(() => import('../scouting-plan-page/scouting-plan-page'));
const ScoutingPlanV2Page = lazyRoute(() => import('./scouting-plan-v2-page'));

export const ScoutingPlanEntryRoute = () => {
  const { companyId, propertyId } = useParams();

  return (
    <FlagGatedRoute
      flag='P40_64319_routing_configuration_v2'
      testId='scouting-plan-entry'
      fallback={
        <Suspense fallback={<Spin fullscreen />}>
          <ScoutingPlanPage />
        </Suspense>
      }>
      <Navigate to={`/company/${companyId}/property/${propertyId}/v2/pest-management/routing`} replace />
    </FlagGatedRoute>
  );
};

const ScoutingPlanV2Route = () => {
  const { companyId, propertyId } = useParams();

  return (
    <FlagGatedRoute
      flag='P40_64319_routing_configuration_v2'
      testId='scouting-plan-v2'
      redirectTo={`/company/${companyId}/property/${propertyId}/pest-management/routing`}>
      <ScoutingPlanV2Page />
    </FlagGatedRoute>
  );
};

export default ScoutingPlanV2Route;
